import logoMultivaBlanco from "@/assets/logo-multiva-blanco.svg";

/**
 * Marca del login en dos variantes:
 *  · "marketing" (panel gradiente naranja): el logotipo oficial en blanco.
 *  · "mobile" (panel form claro): cuadro con la M + texto (el logotipo
 *    oficial es blanco y no funciona sobre fondo claro).
 */
export function MultivaLogo({ variante }: { variante: "mobile" | "marketing" }) {
  if (variante === "marketing") {
    return <img src={logoMultivaBlanco} alt="Grupo Financiero Multiva" className="block h-10 w-auto self-start" />;
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex size-9 items-center justify-center rounded-lg bg-multiva-700 text-lg font-bold text-white">M</div>
      <div>
        <p className="text-sm font-semibold text-foreground">Portal Multiva</p>
        <p className="text-xs text-muted-foreground">Pagos a Proveedores</p>
      </div>
    </div>
  );
}
